module.exports = __webpack_public_path__ + "media/images/ir/common/icon_twitter-bfacf50f88fbf55134427fae88cc8555.svg";